export function initInvitations() {
  // invitations interactions
  if ($("#invitation_role_select").val() == "site_admin") {
    $("#invitation_workspaces_list").hide();
    $("#invitation_staff_accesss_list").hide();
  } else if ($("#invitation_role_select").val() == "site_staff") {
    $("#invitation_workspaces_list").show();
    $("#invitation_staff_accesss_list").show();
  }

  $("#invitation_role_select").change(function () {
    const selected = $(this).val();
    if (selected == "site_admin") {
      $("#invitation_workspaces_list").hide();
      $("#invitation_staff_accesss_list").hide();
    } else if (selected == "site_staff") {
      $("#invitation_staff_accesss_list").show();
      $("#invitation_workspaces_list").show();
    }
  });

  // org invites
  if ($("#invitation_role_select").val() == "organization_admin") {
    $("#invitation_protocols_list").hide();
  } else if ($("#invitation_role_select").val() == "organization_staff") {
    $("#invitation_protocols_list").show();
  }

  $("#invitation_role_select").change(function () {
    const selected = $(this).val();
    if (selected == "organization_admin") {
      $("#invitation_protocols_list").hide();
    } else if (selected == "organization_staff") {
      $("#invitation_protocols_list").show();
    }
  });

  // sponsor invites
  if ($("#invitation_role_select").val() == "sponsor_admin") {
    $("#invitation_protocols_list").hide();
    $("#invitation_labs_list").hide();
  } else if ($("#invitation_role_select").val() == "sponsor_staff") {
    $("#invitation_protocols_list").show();
    $("#invitation_labs_list").show();
  }

  $("#invitation_role_select").change(function () {
    const selected = $(this).val();
    if (selected == "sponsor_admin") {
      $("#invitation_protocols_list").hide();
      $("#invitation_labs_list").hide();
    } else if (selected == "sponsor_staff") {
      $("#invitation_protocols_list").show();
      $("#invitation_labs_list").show();
    }
  });

  // supplier invites
  if ($("#invitation_role_select").val() == "supplier_admin") {
    $("#invitation_protocols_list").hide();
    $("#invitation_depots_list").hide();
    $("#invitation_labs_list").hide();
  } else if ($("#invitation_role_select").val() == "supplier_staff") {
    $("#invitation_protocols_list").show();
    $("#invitation_depots_list").show();
    $("#invitation_labs_list").show();
  }

  $("#invitation_role_select").change(function () {
    const selected = $(this).val();
    if (selected == "supplier_admin") {
      $("#invitation_protocols_list").hide();
      $("#invitation_depots_list").hide();
      $("#invitation_labs_list").hide();
    } else if (selected == "supplier_staff") {
      $("#invitation_protocols_list").show();
      $("#invitation_depots_list").show();
      $("#invitation_labs_list").show();
    }
  });
}
